import type { QuizType, QuizTypeConfig } from '@hooks/step-options/types'
import type { SelectOption } from '@ts-types/common/select/interfaces'

const optionAlmostAlways: SelectOption = {
    id: 'almost-always',
    value: 'Almost always',
    text: '',
    selected: false,
}
const optionSometimes: SelectOption = {
    id: 'sometimes',
    value: 'Sometimes',
    text: '',
    selected: false,
}
const optionRarely: SelectOption = {
    id: 'rarely',
    value: 'Rarely',
    text: '',
    selected: false,
}
const optionAlmostNever: SelectOption = {
    id: 'almost-never',
    value: 'Almost never',
    text: '',
    selected: false,
}
const optionYesEmpty: SelectOption = {
  id: 'yes',
  value: 'Yes',
  text: '',
  selected: false,
}
const optionNoEmpty: SelectOption = {
  id: 'no',
  value: 'No',
  text: '',
  selected: false,
}
const optionNotSure: SelectOption = {
  id: 'not-sure',
  value: 'Not sure yet',
  text: '',
  selected: false,
}

const defaultOptions: SelectOption[] = [
    optionAlmostAlways,
    optionSometimes,
    optionRarely,
    optionAlmostNever,
]
const afterSchoolOptions: SelectOption[] = [
    optionYesEmpty,
    optionNoEmpty,
    optionNotSure,
]

export const answerEnglishLanguageArts = {
  yes: optionYesEmpty.value,
  no: optionNoEmpty.value,
  notSure: optionNotSure.value,
}

export const useOptionsEnglishLanguageArts = (quizType: QuizType): SelectOption[] => {
    const config: QuizTypeConfig = {
        'default': defaultOptions,
        'adhd': defaultOptions,
        'summer-camp': defaultOptions,
        'paid-summer-camp': defaultOptions,
        'quiz15-after-school': afterSchoolOptions,
    }
    return config[quizType]
}
